import { useMemo, useState } from "react";

const MODAL_TYPES = {
  ACTOR: "actor",
  GROUP: "group",
  UNREGISTRATION: "unregistration",
};

export default function useConvocationModals(events) {
  const [activeModal, setActiveModal] = useState(null);
  const [selectedEventId, setSelectedEventId] =
    useState(null);

  const openModal = (modalType, eventId) => {
    setSelectedEventId(eventId);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const currentEvent = useMemo(
    () =>
      events.find(
        (event) =>
          String(event.id) === String(selectedEventId),
      ) ?? null,
    [events, selectedEventId],
  );

  return {
    selectedEventId,
    currentEvent,

    isActorSelectionOpen:
      activeModal === MODAL_TYPES.ACTOR,

    isGroupSelectionOpen:
      activeModal === MODAL_TYPES.GROUP,

    isUnregistrationOpen:
      activeModal === MODAL_TYPES.UNREGISTRATION,

    openActorSelection: (eventId) => {
      openModal(MODAL_TYPES.ACTOR, eventId);
    },

    openGroupSelection: (eventId) => {
      openModal(MODAL_TYPES.GROUP, eventId);
    },

    openUnregistration: (eventId) => {
      openModal(MODAL_TYPES.UNREGISTRATION, eventId);
    },

    closeModal,
  };
}